import { useEffect, useState } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";
import { useParams } from "react-router-dom";

const Droppoints = () => {
  const map = useMap();
  const [droppoints, setDroppoints] = useState([]);
  const {apiKey} = useParams();

  const getDroppoints = async () => {
    const respose = await fetch("api/Droppoint/GetDroppoint/" + apiKey);
    if (respose.ok) {
      const data = await respose.json();
      setDroppoints(data);
    } else {
      console.log("error");
    }
  }

  useEffect(() => {
    getDroppoints();
  }, []);

  // vehicleTypeId is a table in the data warehouse.
  // 2 = regular bike
  // 3 = ebike
  droppoints.forEach((droppoint) => {
    if (droppoint.vehicleKind === 0 && droppoint.visible === true) {
      L.marker([droppoint.latitude, droppoint.longitude], {
        icon: AvailableEbikeIcon,  
      }).addTo(map);
    } else if (droppoint.vehicleKind === 0 && droppoint.visible === false) {
      L.marker([droppoint.latitude, droppoint.longitude], {
        icon: UnavailableEbikeIcon,
      }).addTo(map);
    } else if (droppoint.vehicleKind === 1 && droppoint.visible === true) {
      L.marker([droppoint.latitude, droppoint.longitude], {
        icon: AvailableRegularBikeIcon,
      }).addTo(map);
    } else if (droppoint.vehicleKind === 1 && droppoint.visible === false) {
      L.marker([droppoint.latitude, droppoint.longitude], {
        icon: UnAvailableRegularBikeIcon,
      }).addTo(map);
    }
  });
};

let UnavailableEbikeIcon = L.icon({
  iconUrl: "/map_icons/marker-unavailable_ebike.png",
  iconSize: [50, 60],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
});

let AvailableEbikeIcon = L.icon({
  iconUrl: "/map_icons/marker-available_ebike.png",
  iconSize: [50, 60],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
});

let UnAvailableRegularBikeIcon = L.icon({
  iconUrl: "/map_icons/marker-unavailable_regular.png",
  iconSize: [50, 60],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
});

let AvailableRegularBikeIcon = L.icon({
  iconUrl: "/map_icons/marker-available_regular.png",
  iconSize: [50, 60],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
});

export default Droppoints;